
import CartFavoriteIcon from '../pages/cart/components/CartFavoriteIcon.vue'
import CartInfoIcon from '../pages/cart/components/CartInfoIcon.vue'
import AddToCartBtn from "../pages/cart/components/AddToCartBtn.vue";
import { CmsHomepageModuleEnum } from "@/static/enums/index.js";

export default {
    components: { CartFavoriteIcon, AddToCartBtn, CartInfoIcon },
    props: {
        treatment: {
            type: Object,
            default: null,
            required: true
        },
    },
    data: () => ({
        showDescription: false,
        showFullDescription: false,
        salon: null
    }),
    computed: {
        chainAppointmentButtonOverrideUrl() {
            return this.$store.getters[
                "cmsConfigHomepage/getAppointmentButtonOverrideUrl"
            ];
        },
        bookingActive() {
          return this.$store.getters['salon/bookingEnabledForSite'](this.$store.getters['cart/getSelectedSalon'])
        },
        chainAppointmentButtonOverrideText() {
            return this.$store.getters[
                "cmsConfigHomepage/getAppointmentButtonOverrideText"
            ];
        },
        showReadMoreButton() {
          return this.treatment.description && (this.treatment.description.length > 150 || this.treatment.description.split('\n', 4).length >= 3)
        },
        selectedSalon() {
            var siteIds = this.$route.query.department
            if (siteIds && typeof siteIds === 'string') {
                siteIds = [siteIds]
            }
            if (siteIds && siteIds.length === 1) {
                this.selectedDepartment = +siteIds[0]
                let salon = this.$store.getters['salon/getSalonById'](+siteIds[0])
                return salon
            } else {
                return null;
            }
        },
        showPrice() {
          if (this.selectedSalon) {
            return true
          } else {
            var modules = this.$store.getters["cmsConfigHomepage/getModules"];
            let moduleShowPricesValue = modules.find(
              (m) => m.moduleId == CmsHomepageModuleEnum.PRICES
            )?.visible;
            let prices = true;
            if (moduleShowPricesValue != undefined && moduleShowPricesValue != null)
              prices = moduleShowPricesValue;
            return prices;
          }
        },
        selectedSalonPrice() {
          let siteId = this.selectedSalon && this.selectedSalon.siteId ? this.selectedSalon.siteId : this.$store.getters['cart/getSelectedSalon'];
          let priceSite = this.treatment.pricePerSite.find((doc) => doc.siteId == siteId)
          return priceSite ? priceSite.price : 0
        },
        overrideUrl() {
            if (this.selectedSalon) {
                return this.selectedSalon.appointmentButtonOverrideUrl
                    ? this.selectedSalon.appointmentButtonOverrideUrl
                    : this.chainAppointmentButtonOverrideUrl
                    ? this.chainAppointmentButtonOverrideUrl  : null
            } else {
                return this.chainAppointmentButtonOverrideUrl ? this.chainAppointmentButtonOverrideUrl : null
            }
        },
        overrideText() {
            if (this.selectedSalon) {
                return this.selectedSalon.appointmentButtonOverrideText
                    ?this.selectedSalon.appointmentButtonOverrideText
                    : this.chainAppointmentButtonOverrideText
                    ? this.chainAppointmentButtonOverrideText : null
            } else {
                return this.chainAppointmentButtonOverrideText ? this.chainAppointmentButtonOverrideText : null
            }
        }
    },
    methods: {
        formatPrice(treatment) {
          if (this.showPrice && !this.selectedSalon) {
            if (treatment?.pricePerSite) {
                return Math.min(...treatment?.pricePerSite?.map(x => x.price))
            } else if ('thumbnailImageUrl' in treatment) {
                return treatment.price
            } else {
                return -1
            }
          } else if (this.showPrice && this.selectedSalon) {
            return this.selectedSalonPrice
          }
        },
        treatmentRedirect(treatment) {
            this.$router.push(
                `behandlinger/${treatment.urlSafeTreatmentName}/${treatment.urlSafe}`
            );
        },
        formatDescription(text) {
          return text?.replace(new RegExp('\n', 'g'), '</br>');
        },
        formatTreatmentDuration(durationMinutes) {
            const hours = Math.floor(durationMinutes / 60)
            const minutes = durationMinutes % 60
            const hoursString = hours > 0 ? `${hours + 't '}` : ''
            const minutesString = minutes > 0 ? minutes + ' min' : ''
            return hoursString +  minutesString
        },
        isFavorite(treatment) {
            return this.$store.getters['treatments/getFavoriteTreatments'].map(x => x.treatmentId).includes(treatment.treatmentId)
        },
        treatmentIsInCart(treatment) {
            return this.$store.getters['cart/treatmentIsInCart'](treatment.treatmentId)
        },
        toggleDescription() {
          if (!this.treatment.showDescriptionDefault)  {
            this.showDescription = !this.showDescription
          }
        }
    },
    mounted() {
      this.treatment.showDescriptionDefault ? this.showDescription = true : null;
    }
}
